import { useTranslation } from 'react-i18next'

export default function TotalsSection({ form, fmtMoney }) {
	const { t } = useTranslation()

	return (
		<div className="grid grid-cols-1 md:grid-cols-3 gap-4 px-4 sm:px-0">
			<div className="md:col-span-2" />
			<div className="space-y-2">
				<div className="flex items-center justify-between">
					<span className="text-sm text-gray-600">{t('korekty.form.totals.subtotal')}</span>
					<span className="text-sm font-medium text-gray-900">{fmtMoney(form.subtotal)}</span>
				</div>

				<div className="flex items-center justify-between">
					<span className="text-sm text-gray-600">{t('korekty.form.totals.discountValue')}</span>
					<span className="text-sm font-medium text-gray-900">{fmtMoney(form.discountValue)}</span>
				</div>

				<div className="flex items-center justify-between">
					<span className="text-sm text-gray-600">{t('korekty.form.totals.vatTotal')}</span>
					<span className="text-sm font-medium text-gray-900">{fmtMoney(form.taxTotal)}</span>
				</div>

				<div className="flex items-center justify-between">
					<span className="text-sm text-gray-600">{t('korekty.form.totals.total')}</span>
					<span className="text-sm font-medium text-gray-900">{fmtMoney(form.total)}</span>
				</div>
				
			</div>
		</div>
	)
}
